import React, { useState } from "react";
import ProfDashboardLayout from "../../professional/Profdashboard/ProfDashboardLayout";
import "./style.css";
import { useSelector } from "react-redux";
import Subscription from "../../../components/Subscription/Subscription";

const ProfSubscripiton = () => {
  const user = useSelector((state) => state.AuthSlice.user);

  return (
    <>
      <ProfDashboardLayout>
        <Subscription role={user?.role?.name} />
      </ProfDashboardLayout>
    </>
  );
};

export default ProfSubscripiton;
